// Source/Chat/mod.ts
import { addItem } from "Cart";
var Client_Id = "06ec9d69-1330-4cd0-98e9-01dec2f4021d";
window.addEventListener("PandectesInitialized", () => {
  const consent = Pandectes.currentVisitorConsent();
  const allowed = consent.preferences === "yes" && consent.analytics === "yes" && consent.marketing === "yes";
  update(allowed);
});
window.addEventListener("PandectesConsentUpdate", (event) => {
  const consent = event.detail;
  const allowed = consent.preferences && consent.analytics && consent.marketing;
  update(allowed);
});
function update(allowed) {
  if (!allowed) {
    if (window.Neocom)
      location.reload();
    return;
  }
  if (window.Neocom)
    return;
  loadChat();
}
window.addEventListener("neocomloaded", () => {
  loadSuggestions();
  const theme = loadTheme();
  Neocom.showChatBubble("46dab2c7-d73d-4ade-8c88-5d4dbc2a2445", {
    suggestions: window.NEOCOM_SUGGESTIONS,
    theme
  });
}, { once: true });
window.neocomActionCallback = async (event) => {
  if (event.action !== "ADD_TO_CART")
    return;
  console.debug("Agent ATC", event.data);
  const { title, sku } = event.data;
  const variantId = Number(sku);
  const isSample = title.includes("MUSTER");
  addItem({
    quantity: 1,
    id: variantId
  }, {
    background: true,
    openCart: !isSample
  });
};
window.neocomConsent = () => {
  return {
    cookieConsent: true,
    chatConsent: true
  };
};
function loadChat() {
  loadScript(`https://production.neocomapp.com/neocom.js?id=${Client_Id}`);
}
function loadScript(url) {
  const script = document.createElement("script");
  script.async = true;
  script.type = "text/javascript";
  script.src = url;
  document.head.append(script);
}
function loadTheme() {
  const script = document.querySelector(`#Chat-Theme`);
  const json = script.textContent;
  const data = JSON.parse(json);
  const icon = script.dataset.icon;
  data.chatBubble ??= {};
  data.chatBubble.iconUrl = icon;
  return data;
}
function loadSuggestions() {
  const script = document.querySelector(`#Chat-Topics`);
  if (!script)
    return;
  const json = script.textContent;
  const data = JSON.parse(json);
  console.debug("JSON", json);
  window.NEOCOM_SUGGESTIONS = data;
}
